export const isAuthenticated = (state) => {
  if (!!state.auth.auth.id) return true;
  return false;
};

export const isLoading = (state) => {
  return state.auth.showLoading;
};

export const getUser = (state) => {
  return state.auth.auth;
};
